<template>
  <div class="cc-tab-added" >
     <div class="cctc-title">
      <div class="info">
        今日新增
        <span class="num">{{this.totalCount}}</span> 位用户
      </div>
      <!-- <div class="change" @click="applyAuth(0)">申请认证</div> -->
    </div>
    <van-list v-model="Loading" :finished="finished" finished-text="">
      <div class="cc-box2">
        <div class="cc-list3" v-for="(item, index) in List" :key="'cc-list3-' + index">
          <div class="cc-list3-t">
            <div class="logo">
              <img
                :src="item.avatarUrl?item.avatarUrl:'https://ss2.bdstatic.com/70cFvnSh_Q1YnxGkpoWK1HF6hhy/it/u=188149577,2949073731&fm=26&gp=0.jpg'"
                v-load="'oAvatar'"
              />
            </div>
            <div class="details">
              <div class="line">
                <span class="name">{{item.nickName}}</span>
                <span class="job">{{item.title}}</span>
              </div>
              <div class="info2">{{item.phone}}</div>
            </div>
            <div class="create_time">{{item.createAt}}</div>
          </div>
        </div>
      </div>
    </van-list>
  </div>
</template>

<script>
import moment from "moment";
import { mapGetters, mapActions } from "vuex";
export default {
  name: "added-list",
  data() {
    return {
      Loading: false, //专业买家动态加载状态
      finished: false, //专业买家加载是否完成状态
      List: [], //专业买家列表
      pageSize:12,
      totalCount: 0,
    };
  },
  components: {},
  computed: {
    ...mapGetters({
      exhibitionId: "getExhibitionId",
      userId: "getUserId"
    }),
  },
  created() {this.init()},
  methods: {
    ...mapActions({
      getAddedList: "connection/getAddedList",
    }),
    async init() {
      this.List=[];
      this.finished = false;
      this.Loading = true;
      const data = await this.getAddedList(this.exhibitionId);
      if (!data) {
        this.Loading = false;
        this.finished = true;
        return;
      }
      
      data.userList.forEach(el => {
        // let diff = moment().diff(moment(el.createAt).format('YYYY/MM/DD'), 'days',true);//相差几天
        // el.createAt='2020-05-20 05:40:10';
        let time=moment().from(el.createAt);
        console.log(parseInt(time[0]),time)
        if(time.indexOf('分钟')!=-1){
          el.createAt=parseInt(time)+' 分钟内'
        }else if(time.indexOf('小时')!=-1&&parseInt(time)<8){
          el.createAt=parseInt(time)+' 小时内';
        }else{
          let timeStr=moment(el.createAt).calendar(moment(), {
              sameDay: 'HH:mm',
              lastDay: '[昨天] HH:mm',
              lastWeek: '[上周]dd',
              sameElse: 'YYYY/MM/DD',
          });
          el.createAt=timeStr;
        }
        // console.log(diff);  
        // if(Math.abs(diff)<1){
        //   el.createAt=moment(el.createAt).format('HH:mm');
        // }else if(Math.abs(diff)<2){
        //   el.createAt='昨天 '+moment(el.createAt).format('HH:mm');
        // }else{
        //   el.createAt=moment(el.createAt).format('YYYY/MM/DD HH:mm');
        // }
      });
      this.List=data.userList;
      this.totalCount = data.total;
      this.Loading = false;
      this.finished = true;
    },
    //申请认证
    applyAuth(){
      this.$router.push('/editAuerbach')
    }
  }
};
</script>

<style scoped lang="scss">
//专业买家内容
 .cc {
  &-tab {
    &-added {
      padding-top: 0.7rem;
      .cctc-title {
        position: fixed;
        z-index: 99;
        top: 1rem;
        left: 0;
        right: 0;
        background:#131825;
        display: flex;
        padding: 0.14rem 0.24rem 0.14rem;
        align-items: center;
        justify-content: space-between;
        .info {
          font-size: 0.2rem;
          color: #bfbfbf;
          margin-right: 0.2rem;
          max-width: 50%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          .num {
            color: #fff;
          }
        }
        .change {
          color: #f85b0f;
        }
        .btn {
          flex: 1;
          text-align: right;
          button {
            background-color: transparent;
          }
        }
      }
    }
  }
  &-box2 {
    padding: 0 0.24rem;
    .cc-list3 {
      padding: 0.2rem;
      margin-bottom: 0.2rem;
      background-color: #1d2435;
      border-radius: 0.05rem;
      color: #fff;
      &-t {
        display: flex;
        .logo {
          position: relative;
          width: 0.88rem;
          height: 0.88rem;
          margin-right: 0.14rem;
          img {
            border-radius: 50%;
            width: 100%;
            height: 100%;
            // object-fit: cover;
          }
        }
        .details {
          .line {
            display: flex;
            align-items: flex-end;
            margin-bottom: 0.16rem;
            padding-top: 0.1rem;
            .name {
              font-size: 0.24rem;
              margin-right: 0.1rem;
              font-weight: 400;
            }
            .job {
              font-size: 0.2rem;
            
            }
          }
          .interest{
            overflow: hidden;
            text-overflow:ellipsis;
            white-space: nowrap;
            height: 0.32rem;
            span{
              display: inline-block;
              height: 0.32rem;
              padding:0 0.11rem;
              font-size: 0.2rem;
              margin-left: 0.1rem;
              background: #333d56;
              border-radius: 0.03rem;
                &:first-child{
                margin-left:0;
              }
            }
          }
          .info2 {
            font-size: 0.2rem;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
        .txt {
          width: 2rem;
          padding-top: 0.16rem;
          text-align: right;
          font-size: 0.2rem;
          color: #bfbfbf;

          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .create_time{
          margin-left: auto;
          flex-shrink: 0;
          font-size: 0.2rem;
          color: #bfbfbf;
        }
      }
      &-gx{
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      &-b {
        display: flex;
        .cclb {
          &-l {
            font-size: 0.2rem;
            width: 80%;
            padding-top: 0.13rem;
            .txt2 {
              color: #ffcc00;
              width: calc(100% - 1px);
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            .txt3 {
              width: calc(100% - 1px);
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
          &-r {
            width: 20%;
            text-align: right;
            .btn {
              height: 0.48rem;
              line-height: 0.48rem;
              display: inline-block;
              padding: 0 0.2rem;
              background-color: #f85b0f;
              border-radius: 0.04rem;
            }
          }
        }
      }
    }
  }
  }
</style>
